export const CONST = {
  typeList: [
    { label: '全部', value: 'ALL'},
    { label: '国家标准', value: 'ZGJ' },
    { label: '行业标准', value: 'ZHY' },
    { label: '地方标准', value: 'ZDF' },
    { label: '团体标准', value: 'ZTT' },
    { label: '国际标准', value: 'GJ' },
    { label: '国外标准', value: 'GW' },
    // { label: '其它标准', value: 7 },
  ],
  timeList: [
    { label: '全部', value: 'ALL'},
    { label: '近三个月', value: '0' },
    { label: '近一年', value: '1' },
    { label: '近两年', value: '2' },
    { label: '近三年', value: '3' },
  ],
  statusList: [
    { label: '全部', value: 'ALL'},
    { label: '现行', value: 'ST' },
    { label: '未现行', value: 'NST' },
    { label: '废止', value: 'WT' },
    { label: '其它', value: 'OTHER' },
  ],
  productList: [
    { label: '全部', value: 'ALL'},
    { label: '通用基础', value: 18, icon: 'base-use' },
    { label: '建筑相关产品', value: 1, icon: 'community' },
    { label: '食品和饮料', value: 2, icon: 'bowl' },
    { label: '机械设备', value: 3, icon: 'settings' },
    { label: '化学产品', value: 4, icon: 'flask' },
    { label: '金属、矿物、塑料和玻璃制品', value: 5, icon: 'coin' },
    { label: '纺织品、鞋类和服装', value: 6, icon: 't-shirt' },
    { label: '服务', value: 7, icon: 'service' },
    { label: '纸和塑料制品', value: 8, icon: 'file1' },
    { label: '车辆和运输设备', value: 9, icon: 'car' },
    { label: '办公设备及家用电器设备', value: 10, icon: 'radio' },
    { label: '基础设施和建筑', value: 11, icon: 'stairs' },
    { label: '家具及其他商品', value: 12, icon: 'sofa' },
    { label: '电力、蒸汽和燃料', value: 13, icon: 'plug' },
    { label: '计算机、通信和其他电子设备制造', value: 14, icon: 'computer' },
    { label: '橡胶', value: 15, icon: 'egg' },
    { label: '废弃资源综合利用', value: 16, icon: 'recycle' },
    { label: '木制品', value: 17, icon: 'tree' },
  ],
  organizationsList: [
    { label: '全部', value: 'ALL'},
    { label: '国际', value: 6 },
    { label: '欧盟', value: 1 },
    { label: 'UL Environment', value: 2 },
    { label: '日本', value: 3 },
    { label: '韩国', value: 4 },
    { label: '挪威', value: 5 },
    // { label: '中国', value: 7 },
  ]
}